<nb-card class="dialog-container">
    <nb-card-header>Télécharger un fichier</nb-card-header>
    <nb-card-body>
        <div class="upload-content">
            <div (click)="fileInput.click()" class="file-upload">
                <input hidden #fileInput type="file" multiple (change)="onInputChange($event)">
                <nb-icon class="file-upload-icon" icon="upload-outline">
                </nb-icon>
            </div>
            <div class="files-container">
                <div class="files-content" appDragDrop (dropHandler)="uploadFile($event)">
                    <div class="file-element" *ngIf="!fileInputRef?.nativeElement?.files?.length">
                        &nbsp; Aucun fichier choisi &nbsp;
                    </div>
                    <ng-container *ngIf="fileInputRef?.nativeElement?.files?.length">
                        <div class="file-element" *ngFor="let file of fileInputRef.nativeElement.files ">
                            &nbsp; {{file.name }} &nbsp;
                        </div>
                    </ng-container>
                </div>
            </div>


        </div>
    </nb-card-body>
    <nb-card-footer>
        <button nbButton status="primary" (click)="onSaveClick()" hero>Valider</button>
        <button nbButton status="info" (click)="onCancelClick()" hero>Annuler</button>
    </nb-card-footer>
</nb-card>